export enum FieldName {
  Age = "age",
  CollectionsBalance = "collections_balance", // type: any
  CollectionsBalanceRental = "collections_balance_rental", // type: any (rental accounts only)
  GrossIncome = "gross_income", // type: total
  GrossIncomeToRentRatio = "gross_income_to_rent_ratio", // type: total
  NetIncome = "net_income", // total,
  DebtToNetIncome = "debt_to_net_income", // type: total,
  SelfReportedGrossIncome = "self_reported_gross_income",
  SelfReportedGrossIncomeToRentRatio = "self_reported_gross_income_to_rent_ratio",
  DebtToSelfReportedGrossIncome = "debt_to_self_reported_gross_income",
  DebtToGrossIncome = "debt_to_gross_income",
  // Number of accounts
  CreditScore = "credit_score", // type: average
  PastDueAccount = "past_due_account", // type: any_number any_percentage
  PastDueRentalAccount = "past_due_rental_account", // type: any_number any_percentage (rental accounts only)
  UnpaidCollectionsBalance = "unpaid_collections_balance", // type: any
  UnpaidCollectionsBalanceRental = "unpaid_collections_balance_rental", // type: any (rental accounts only)
  BankruptcyRecords = "bankruptcy_records", // type: any
  SexOffenderCheck = "sex_offender_check", // type: any
  HousingCourtRecords = "housing_court_records", // type: any
  NoCreditScore = "no_credit_score", // type: any
  FelonyRecords = "felony_records", // type: any
  MisdemeanorRecords = "misdemeanor_records",
  OfacRecords = "ofac_records",
  OtherCriminalRecords = "other_criminal_records",
  AllCriminalRecords = "all_criminal_records",
  IncomeDocumentFraudCheck = "income_document_fraud_check",
  ForeclosureAccounts = "foreclosure_accounts"
}

export enum Operator {
  GreaterThan = ">",
  GreaterEqualThen = ">=",
  LessThan = "<",
  LessEqualThen = "<=",
  Equal = "==",
  NotEqual = "!="
}

export enum TimeFrame {
  All = "all_time",
  Within1Year = "within_1_year",
  Within2Years = "within_2_years",
  Within3Years = "within_3_years",
  Within4Years = "within_4_years",
  Within5Years = "within_5_years",
  Within6Years = "within_6_years",
  Within7Years = "within_7_years",
  Within8Years = "within_8_years",
  Within9Years = "within_9_years",
  Within10Years = "within_10_years",
  Within11Years = "within_11_years",
  Within12Years = "within_12_years",
  Within13Years = "within_13_years",
  Within14Years = "within_14_years",
  Within15Years = "within_15_years"
}

export enum GroupType {
  Anyone = "anyone_in_group", // previously - field_type any
  Everyone = "everyone_in_group", // previously - field_type all
  Average = "group_average", // previously - field_type average
  Combined = "group_combined" // previously - field_type sum
}

export enum FieldType {
  Numeric = "numeric",
  Percentage = "percentage",
  // Deprecated values, shouldn't exist after migration to GroupType usage
  Any = "any",
  Sum = "sum",
  All = "all"
}

export enum GroupRole {
  All = "all",
  Applicant = "applicant",
  CoSigner = "co_signer",
  Occupant = "occupant"
}

export enum BankruptcyStatus {
  All = "all",
  Open = "open"
}

export enum AccountType {
  All = "all",
  Rental = "rental"
}

export type Rule = {
  id: string;
  field_name: FieldName;
  field_type?: FieldType | TimeFrame;
  group_type?: GroupType;
  operator: Operator;
  value: string;
  threshold?: string | number;
  result?: boolean;
  computed_value?: number;
  group_role?: GroupRole;
  bankruptcy_status?: BankruptcyStatus;
  skipped?: boolean;
  per_applicant_results?: {
    applicant_id: number;
    value: number;
    result: boolean;
  }[];
};

export enum RuleSetDecision {
  Decline = "decline",
  Approve = "approve",
  ConditionalApprove = "conditional_approve"
}

export type RuleSet = {
  id: string;
  type: RuleSetDecision;
  rules: Rule[];
};
